import styled from 'styled-components'

const Text = styled.h2`
  font-style: normal;
  font-family: 'Space Grotesk';
  font-weight: 800;
  font-size: 48px;
  letter-spacing: 4.8px;
  padding: 200px 0;
  text-align: center;
  z-index: 10;
  transition: 0s;
  text-transform: uppercase;
`

const NotFound = () => {
  return <Text>Project not found</Text>
}

export default NotFound
